import i18n from '~/i18n'
import { defineStore } from 'pinia'
import { ref } from 'vue'

const TIMEOUT = 6000

export const useSnackbarStore = defineStore('snackbar', () => {
  const visible = ref(false)
  const color = ref('primary')
  const text = ref<any>('works')
  const timeout = ref(6000)

  const resetState = () => {
    visible.value = false
    color.value = 'primary'
    text.value = 'works'
    timeout.value = 6000
  }

  const hideSnackbar = () => {
    timeout.value = 6000
    visible.value = false
  }

  const showSnackbar = ({
    color: snackColor,
    text: snackText,
    timeout: snackTimeout,
  }: {
    color?: string
    text?: any
    timeout?: number
  }) => {
    color.value = snackColor || 'primary'
    text.value = snackText || i18n.t('FormView.saved').toString()
    timeout.value = snackTimeout || 6000
    visible.value = true

    setTimeout(() => {
      hideSnackbar()
    }, TIMEOUT)
  }

  const showSnackbarInfinity = ({
    color: snackColor,
    text: snackText,
  }: {
    color?: string
    text?: any
  }) => {
    color.value = snackColor || 'primary'
    text.value = snackText || i18n.t('FormView.saved').toString()
    timeout.value = -1
    visible.value = true
  }

  return {
    visible,
    color,
    text,
    timeout,
    resetState,
    showSnackbar,
    showSnackbarInfinity,
    hideSnackbar,
  }
})
